import Plugin from '../core/Plugin';
import { PlayerEvent } from '../PlayerEvents';
import { KV } from '../core/Constant';
import { VHVideoConfig } from '../config';
import log from 'loglevel';

/**
 * 直播暂停后播放逻辑优化插件
 *
 * @export
 * @class PlayCurrentTime
 * @extends {Plugin}
 */

// IOS环境下暂停再恢复时，重新load会造成黑屏。
// 因此暂停超过此时间，才执行load
const MIN_IOS_PAUSE_PLAY_RELOAD_DURATION = 5;
export default class PlayCurrentTime extends Plugin {
  constructor() {
    super();
    this._allConfig = null;
  }

  init(opts = {}) {
    if (!opts.isLive) {
      log.debug('点播不运行暂停恢复逻辑');
      return;
    }
    if(opts.isOpenTimeshift && opts.type === 'hls') {
      log.debug('直播时移不运行暂停恢复逻辑');
      return;
    }
    if(opts.type === 'rtl') {
      log.info('快直播不运行暂停恢复逻辑');
      return;
    }

    super.init(opts);
    this._allConfig = opts;
    this.pauseTime = 0;
    this._handleCareEvent();
  }

  _handleCareEvent() {
    this.player.on(PlayerEvent.PLAY, this._play.bind(this));
    this.player.on(PlayerEvent.PAUSE, this._pause.bind(this));
  }

  _pause() {
    this.pauseTime = Date.now();
  }

  _play() {
    // 非正常收到play事件
    if (this.pauseTime === null) {
      log.info(`直播暂停恢复 -> 忽略本次play事件`);
      return;
    }

    // 首次播放时，可能由于未自动播放或自动播放失败，导致缓冲区过大，播放延迟过大
    // 如缓冲区长度大于某容忍长度，则追播至最新
    const pursueConfig = JSON.parse(this._allConfig.plugin_pursue);
    let bufferMax = 10;
    let remain = 2;
    switch (this._allConfig.type) {
      case 'flv':
        const flvConfig = pursueConfig['flv'];
        bufferMax = flvConfig['bufferMax']
        remain = flvConfig['remain'];
        break;
      case 'hls':
        const hlsConfig = pursueConfig['hls'];
        bufferMax = hlsConfig['bufferMax']
        remain = hlsConfig['remain'];
        break;
      default:
        break;
    }
    
    if (this.pauseTime >= 0) {
      const currentTime = this.player.getCurrentTime();
      const buffered = this.player.getBuffered();
      const bufferTime = buffered.length > 0 ? buffered.end(buffered.length - 1) : 0;
      log.info(`直播暂停恢复，pauseTime为${this.pauseTime}，currentTime为${currentTime}秒，buffered为${bufferTime}秒`);

      if (isFinite(bufferTime)) {
        if (bufferTime - currentTime > bufferMax) {
          if (this.player.context['os'] == 'ios' &&
                (this.player.player.CLASS_NAME == 'NativePlayer' || this.player.player.TAG == 'NativePlayer')) {
            // 注意：ios设置currentTime无效，因此尝试重新加载
            log.info('直播暂停恢复 -> IOS环境下重新拉流');
            this.player.player.video.load();
            this.player.play();
          } else {
            const seekTime = bufferTime - remain;
            if (seekTime > 0) {
              log.info(`直播暂停恢复 -> seek至${seekTime}秒`);
              this.player.setCurrentTime(seekTime);
            }
          }
        } else {
          //缓冲区长度小，不处理
        }
      } else {
        //不支持buffere属性，暂不处理
      }

      this.pauseTime = null;
      return;
    }
  }

  destroy() {
    super.destroy();
    this.player.off(PlayerEvent.PLAY, this._play);
    this.player.off(PlayerEvent.PAUSE, this._pause);
  }

  static get type() {
    return 'plugin_playCurrentTime';
  }
}
